// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__16bAJ","bigColWidth":"Table_bigColWidth__3qd0T","biggerColWidth":"Table_biggerColWidth__qlKxl","row":"Table_row__24bkJ","col":"Table_col__DINM8"};